import axios from "@axios" //eslint-disable-line

export default {
    /*
     * main creatives API
     */
    getCreatives(params = {}) {
        return axios.get('/creatives', { params })
    },
    getCreativesPaginated(params) {
        return axios.get('/creatives/paginated', { params })
    },
    deleteCreative(uuid) {
        return axios.delete(`/creatives/${uuid}`)
    },
    addCreative(data) {
        const postData = {
            ...data,
        }
        return axios.post('/creatives', postData)
    },
    getCreative(uuid) {
        return axios.get(`/creatives/${uuid}`)
    },
    getCreativeHistory(uuid) {
        return axios.get(`/creatives/${uuid}/history`)
    },
    updateCreative(uuid, payload) {
        return axios.put(`/creatives/${uuid}`, payload)
    },
    validateName(payload) {
        return axios.post('/creatives/validate-name', payload)
    },

    /*
     * admin creatives API
     */
    getCreativesForReview() {
        return axios.get('/creatives/review')
    },
    updateCreativeStatus(uuid, creative) {
        return axios.put(`/creatives/${uuid}/review`, creative)
    },
    getCreativeForReview(uuid) {
        return axios.get(`/creatives/${uuid}/review`)
    },
    getCreativeRejectReasons() {
        return axios.get('/creatives/reject-reasons')
    },
    getPassthroughFieldsList() {
        return axios.get('/passthrough-fields')
    },
}
